import Footer from './Footer';
import connectContainer from './FooterContainer';

export default connectContainer(Footer);
